import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';
import ProductStepperStep from './ProductStepperStep';

function CloseIcon(props) {
  return (
    <SvgIcon viewBox="0 0 16 16" style={{color: '#fff', fontSize: 20}} {...props}>
      <path d="M9.29297 7.75L13.7188 3.36719L14.6211 2.46484C14.75 2.33594 14.75 2.12109 14.6211 1.94922L13.6758 1.00391C13.5039 0.875 13.2891 0.875 13.1602 1.00391L7.875 6.33203L2.54688 1.00391C2.41797 0.875 2.20312 0.875 2.03125 1.00391L1.08594 1.94922C0.957031 2.12109 0.957031 2.33594 1.08594 2.46484L6.41406 7.75L1.08594 13.0781C0.957031 13.207 0.957031 13.4219 1.08594 13.5938L2.03125 14.5391C2.20312 14.668 2.41797 14.668 2.54688 14.5391L7.875 9.21094L12.2578 13.6367L13.1602 14.5391C13.2891 14.668 13.5039 14.668 13.6758 14.5391L14.6211 13.5938C14.75 13.4219 14.75 13.207 14.6211 13.0781L9.29297 7.75Z" />
    </SvgIcon>
  );
}
function WordsIcon(props) {
  return (
    <SvgIcon width="50" height="50" viewBox="0 0 50 50" fill="none" style={{color: '#fff', fontSize: 50}} {...props}>
      <rect width="50" height="50" fill="#01569D" />
      <g clipPath="url(#clip0_988_8048)">
        <rect width="50" height="50" fill="#EE4127" />
        <path d="M24.6292 43L35 53H14L24.6292 43Z" fill="white" />
      </g>
      <path
        d="M38.5625 28.125H27.1875C26.9141 28.125 26.75 28.3438 26.75 28.5625V29.4375C26.75 29.7109 26.9141 29.875 27.1875 29.875H38.5625C38.7812 29.875 39 29.7109 39 29.4375V28.5625C39 28.3438 38.7812 28.125 38.5625 28.125ZM38.5625 35.125H27.1875C26.9141 35.125 26.75 35.3438 26.75 35.5625V36.4375C26.75 36.7109 26.9141 36.875 27.1875 36.875H38.5625C38.7812 36.875 39 36.7109 39 36.4375V35.5625C39 35.3438 38.7812 35.125 38.5625 35.125ZM38.5625 21.125H27.1875C26.9141 21.125 26.75 21.3438 26.75 21.5625V22.4375C26.75 22.7109 26.9141 22.875 27.1875 22.875H38.5625C38.7812 22.875 39 22.7109 39 22.4375V21.5625C39 21.3438 38.7812 21.125 38.5625 21.125ZM38.5625 14.125H27.1875C26.9141 14.125 26.75 14.3438 26.75 14.5625V15.4375C26.75 15.7109 26.9141 15.875 27.1875 15.875H38.5625C38.7812 15.875 39 15.7109 39 15.4375V14.5625C39 14.3438 38.7812 14.125 38.5625 14.125ZM22.8125 35.125H11.4375C11.1641 35.125 11 35.3438 11 35.5625V36.4375C11 36.7109 11.1641 36.875 11.4375 36.875H22.8125C23.0312 36.875 23.25 36.7109 23.25 36.4375V35.5625C23.25 35.3438 23.0312 35.125 22.8125 35.125ZM22.8125 28.125H11.4375C11.1641 28.125 11 28.3438 11 28.5625V29.4375C11 29.7109 11.1641 29.875 11.4375 29.875H22.8125C23.0312 29.875 23.25 29.7109 23.25 29.4375V28.5625C23.25 28.3438 23.0312 28.125 22.8125 28.125ZM22.8125 14.125H11.4375C11.1641 14.125 11 14.3438 11 14.5625V15.4375C11 15.7109 11.1641 15.875 11.4375 15.875H22.8125C23.0312 15.875 23.25 15.7109 23.25 15.4375V14.5625C23.25 14.3438 23.0312 14.125 22.8125 14.125ZM22.8125 21.125H11.4375C11.1641 21.125 11 21.3438 11 21.5625V22.4375C11 22.7109 11.1641 22.875 11.4375 22.875H22.8125C23.0312 22.875 23.25 22.7109 23.25 22.4375V21.5625C23.25 21.3438 23.0312 21.125 22.8125 21.125Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_988_8048">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

const ProductStepper = ({onClickStep, activeStep, onClickClose}) => {
  return (
    <div className="product-stepper">
      <div>
        <ProductStepperStep stepName="WORDS" activeStep={activeStep}>
          <WordsIcon onClick={() => onClickStep('WORDS')} />
        </ProductStepperStep>
      </div>

      <div className="product-stepper-actions">
        <CloseIcon className="product-stepper-action" onClick={onClickClose} />
      </div>
    </div>
  );
};

ProductStepper.propTypes = {
  onClickStep: PropTypes.func.isRequired,
  activeStep: PropTypes.string.isRequired,
  onClickClose: PropTypes.func.isRequired,
};

export default ProductStepper;
